import axiosPost from "./axiosPost";

export const RNPSAsignacionDel = async (credentials, data) => {
    const body = {
        service: "RNPSAsignacionDel",
        params: {
            rnpsAsignacionId: data?.asignacionId,
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
